export default () => {
    const navItems = document.querySelectorAll('.js-support-menu-item');
    
    if (window.location.hash) {
        setTimeout(function () {
            scrollToHash( window.location.hash)
        }, 300);
    }
    
    function scrollToHash(hash) { 
        let sectionDistanceFromTop = document.querySelector(hash).offsetTop;
        if(document.querySelector('.Header')){
            const headerHeight = document.querySelector('.Header').offsetHeight;
            document.documentElement.scrollTop = sectionDistanceFromTop - (headerHeight * 2) ;
        }
    }

    if (navItems) {
        navItems.forEach(element => {
            element.addEventListener('click', e => {
                scrollToHash(e.currentTarget.hash);
            })
        });
    }
}